module.exports = [{"serverid":1,"servername":"青澜仙府"},{"serverid":2,"servername":"渡劫封仙"},{"serverid":3,"servername":"龙余仙岛"}]


//////////////////
// WEBPACK FOOTER
// ./src/api/serverlist.json
// module id = Fb+H
// module chunks = 1